import { useRef } from 'react';

import { Icon } from '../components/Icon.js';
import styles from './WidgetSearch.module.css';

interface WidgetSearchProps {
  value: string;
  onChange: (value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
}

/** The widget home's search box. The ✕ is the one thing `/chat`'s box lacks: at
 *  400px there is no column to backspace through. */
export function WidgetSearch({ value, onChange, onFocus, onBlur }: WidgetSearchProps) {
  const input = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.search}>
      <span className={styles.icon}>
        <Icon name="search" size={17} />
      </span>
      <input
        ref={input}
        className={styles.input}
        type="search"
        value={value}
        placeholder="Search name, message or job"
        aria-label="Search name, message or job"
        onChange={(event) => onChange(event.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {value !== '' && (
        <button
          type="button"
          className={styles.clear}
          aria-label="Clear search"
          // Keeps focus in the box, so clearing is backspacing, not leaving the search.
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => {
            onChange('');
            input.current?.focus();
          }}
        >
          <Icon name="close" size={14} />
        </button>
      )}
    </div>
  );
}
